/**
 * 社媒配置
 */
export const SHARE_METHOD_CONFIG = [
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'ru', 'th'],
    order: {
      en: 1,
      ja: 1,
      ko: 2,
      'zh-Hant': 1,
      es: 1,
      pt: 1,
      de: 1,
      fr: 1,
      ru: 2,
      th: 1
    },
    linkLocales: {
      en: 'https://discord.gg/mechabreak',
      ja: 'https://discord.gg/mechabreak',
      ko: 'https://discord.gg/mechabreak',
      'zh-Hant': 'https://discord.gg/6UdhNM8fNw',
      es: 'https://discord.gg/mechabreak',
      pt: 'https://discord.gg/mechabreak',
      de: 'https://discord.gg/mechabreak',
      fr: 'https://discord.gg/mechabreak',
      ru: 'https://discord.gg/mechabreak',
      th: 'https://discord.gg/mechabreak'
    },
    name: 'Discord',
    onClick() {}
  },
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'th'],
    order: {
      en: 2,
      ja: 2,
      ko: 3,
      'zh-Hant': 3,
      es: 2,
      pt: 2,
      de: 2,
      fr: 2,
      th: 3
    },
    linkLocales: {
      en: 'https://x.com/MechaBREAK',
      ja: 'https://x.com/MechaBREAKJP',
      ko: 'https://x.com/MechaBREAK_KR',
      'zh-Hant': 'https://x.com/MechaBREAKSea',
      es: 'https://x.com/MechaBREAK',
      pt: 'https://x.com/MechaBREAK',
      de: 'https://x.com/MechaBREAK',
      fr: 'https://x.com/MechaBREAK',
      th: 'https://x.com/MechaBREAK'
    },
    // name: 'X (Twitter)',
    name: 'X',
    onClick() {}
  },
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'ru', 'th'],
    order: {
      en: 3,
      ja: 3,
      ko: 4,
      'zh-Hant': 4,
      es: 3,
      pt: 3,
      de: 3,
      fr: 3,
      ru: 3,
      th: 4
    },
    linkLocales: {
      en: 'https://www.youtube.com/@MechaBREAK',
      ja: 'https://www.youtube.com/@MechaBREAKJP',
      ko: 'https://www.youtube.com/@MechaBREAK_KR',
      'zh-Hant': 'https://www.youtube.com/@MechaBREAEK_Sea',
      es: 'https://www.youtube.com/@MechaBREAK',
      pt: 'https://www.youtube.com/@MechaBREAK',
      de: 'https://www.youtube.com/@MechaBREAK',
      fr: 'https://www.youtube.com/@MechaBREAK',
      ru: 'https://www.youtube.com/@MechaBREAK',
      th: 'https://www.youtube.com/@MechaBREAK'
    },
    name: 'YouTube',
    onClick() {}
  },
  {
    applyLanguages: ['en', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'th'],
    order: {
      en: 4,
      'zh-Hant': 2,
      es: 4,
      pt: 4,
      de: 4,
      fr: 4,
      th: 2
    },
    linkLocales: {
      en: 'https://www.facebook.com/MechaBREAK/',
      'zh-Hant': 'https://www.facebook.com/profile.php?id=61560861745459',
      es: 'https://www.facebook.com/MechaBREAK/',
      pt: 'https://www.facebook.com/MechaBREAK/',
      de: 'https://www.facebook.com/MechaBREAK/',
      fr: 'https://www.facebook.com/MechaBREAK/',
      th: 'https://www.facebook.com/groups/mechabreakthai'
    },
    name: 'Facebook',
    onClick() {}
  },
  {
    applyLanguages: ['en', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'th'],
    order: {
      en: 5,
      ko: 5,
      'zh-Hant': 5,
      es: 5,
      pt: 5,
      de: 5,
      fr: 5,
      th: 5
    },
    linkLocales: {
      en: 'https://www.instagram.com/mechabreak/',
      ko: 'https://www.instagram.com/mechabreak/',
      'zh-Hant': 'https://www.instagram.com/mechabreak/',
      es: 'https://www.instagram.com/mechabreak/',
      pt: 'https://www.instagram.com/mechabreak/',
      de: 'https://www.instagram.com/mechabreak/',
      fr: 'https://www.instagram.com/mechabreak/',
      th: 'https://www.instagram.com/mechabreak/'
    },
    name: 'Instagram',
    onClick() {}
  },
  {
    applyLanguages: ['en'],
    order: {
      en: 6
    },
    linkLocales: {
      en: 'https://www.tiktok.com/@mechabreak'
    },
    name: 'TikTok',
    onClick() {}
  },
  {
    applyLanguages: ['en', 'ja', 'ko', 'zh-Hant', 'es', 'pt', 'de', 'fr', 'ru', 'th'],
    order: {
      en: 7,
      ja: 4,
      ko: 6,
      'zh-Hant': 6,
      es: 6,
      pt: 6,
      de: 6,
      fr: 6,
      ru: 4,
      th: 6
    },
    linkLocales: {
      en: 'https://www.twitch.tv/mechabreakofficial',
      ja: 'https://www.twitch.tv/mechabreakofficial',
      ko: 'https://www.twitch.tv/mechabreakofficial',
      'zh-Hant': 'https://www.twitch.tv/mechabreakofficial',
      es: 'https://www.twitch.tv/mechabreakofficial',
      pt: 'https://www.twitch.tv/mechabreakofficial',
      de: 'https://www.twitch.tv/mechabreakofficial',
      fr: 'https://www.twitch.tv/mechabreakofficial',
      ru: 'https://www.twitch.tv/mechabreakofficial',
      th: 'https://www.twitch.tv/mechabreakofficial'
    },
    name: 'Twitch',
    onClick() {}
  },
  {
    applyLanguages: ['ko'],
    order: {
      ko: 1
    },
    linkLocales: {
      ko: 'https://game.naver.com/lounge/Mecha_BREAK'
    },
    name: 'Naver',
    onClick() {}
  },
  {
    applyLanguages: ['ru'],
    order: {
      ru: 1
    },
    linkLocales: {
      ru: 'https://vk.com/mechabreak'
    },
    name: 'VK',
    onClick() {}
  }
];

/**
 * @description 平台信息
 * @type {Array}
 */
export const PLAYFORM = [
  {
    label: '哔哩哔哩',
    qrcode: require('@src/business-components/modals/images/qrcode-bilibili.png'),
    link: 'https://space.bilibili.com/3493282537540091?spm_id_from=333.1007.0.0',
    linkText: '进入B站',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '公众号',
    qrcode: require('@src/business-components/modals/images/qrcode-gzh.png'),
    link: '',
    linkText: '扫码关注',
    linkTheme: 'dark',
    clickable: false
  },
  {
    label: '抖音',
    qrcode: require('@src/business-components/modals/images/qrcode-douyin.png'),
    link: 'https://www.douyin.com/user/MS4wLjABAAAA91Y1f9H4q0ImiT7d4f4KpY9SSiOLWZjjcxzB1jMpaZAdfvZgu5VcPsbWntIq6Qs3?from_tab_name=main',
    linkText: '进入抖音',
    linkTheme: 'light',
    clickable: true
  },
  {
    label: '小红书',
    qrcode: require('@src/business-components/modals/images/qrcode-xhs.png'),
    link: 'https://www.xiaohongshu.com/user/profile/67526aaf000000001d02cc5d?xsec_token=AB7tgXqhObA3WGPvojS-bbuJXbUKneJFN4ucrFOmqkNJ0=&xsec_source=pc_search',
    linkText: '进入小红书',
    linkTheme: 'light',
    clickable: true
  }
];

/**
 * @description 轮询获取是否已预约的时间限制
 * @type {Number}
 */
export const POLLING_CHECK_LOGIN_STATUS_MAX_TIME = 60000;

// 公测阶段
export const PAGE_STAGE = {
  // 预约阶段
  appointment: { isOpen: 1, isClose: 0 },
  // 下载阶段
  download: { isOpen: 1, isClose: 0 }
};
